export default function createLinkId(source: string, target: string) {
  return `${source}**${target}`
}
